import NextLink from 'next/link';
import { Text, Link, Center } from '@chakra-ui/react';

import { ASTONDEVS_URL } from 'constants/global';

const NdaAgreement = () => (
  <Center w="full" p={{ tablet: '11px 24px' }}>
    <Text textAlign="center" textStyle="b4" maxW={{ tablet: '580px', laptop: '585px' }}>
      Нажимая на кнопку «Стать лидером», вы соглашаетесь на&nbsp;
      <Link
        as={NextLink}
        href={`${ASTONDEVS_URL}personal-data`}
        isExternal
        textStyle="b4"
        fontWeight="500"
        textDecoration="underline"
        textUnderlineOffset="0.25em"
      >
        обработку персональных данных
      </Link>{' '}
      и&nbsp;c&nbsp;
      <Link
        as={NextLink}
        href={`${ASTONDEVS_URL}confidentiality`}
        isExternal
        textStyle="b4"
        fontWeight="500"
        textDecoration="underline"
        textUnderlineOffset="0.25em"
      >
        правилами пользования
      </Link>
    </Text>
  </Center>
);

export default NdaAgreement;
